// import createPersistedState from "vuex-persistedstate";
import Vuex from 'vuex';
import Vue from 'vue';

import userStore from './store/user';
import schoolStore from './store/school';
import stageStore from './store/stage';
import referenceStore from './store/reference';
import loadingStore from './store/loading';
import typestore from './store/schtype';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        user: userStore,
        school: schoolStore,
        stage: stageStore,
        reference: referenceStore,
        loading: loadingStore,
        schtype: typestore,
    },
    // plugins: [createPersistedState({
    //     paths: ['user.token']
    // })],
});

export default store;
